import { ERROR_EMPTY_PRODUCTCLASSCODE, ERROR_MINIMUM_PRODUCTCLASSCODE, ERROR_EMPTY_PRODUCTCLASSNAME, ERROR_INVALID_PRODUCTCLASSCODE } from "../../../../utils/messages";
import { isNullOrEmpty, isWholeNumber } from "../../../../utils/common";
import { EMPTY_COUNT } from "../../../../utils/constants";

function validate(payload) {

    let prompt = [];

    if (isNullOrEmpty(payload.productClassCode)) {
        prompt.push(ERROR_EMPTY_PRODUCTCLASSCODE);
    }else if(!isWholeNumber(payload.productClassCode)){
        prompt.push(ERROR_INVALID_PRODUCTCLASSCODE);
    }

    if (EMPTY_COUNT > payload.productClassCode) {
        prompt.push(ERROR_MINIMUM_PRODUCTCLASSCODE);
    }

    if (isNullOrEmpty(payload.productClassName)) {
        prompt.push(ERROR_EMPTY_PRODUCTCLASSNAME);
    }

    return prompt;
}


export {
    validate,
};